/**
 * Created by Carsten Bühler
 * User: c.buehler on 09.06.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';


import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Button } from 'external/react-bootstrap';
import { translation } from 'plugin/liferay-widgets-react-web';


const DataSourcesTableItem = function ({ item, onClickEdit, onClickDelete }) {
    return (
        <tr>
            <td>{item.title}</td>
            <td>{item.typeKey}</td>
            <td>{item.config}</td>
            <td>
                <Button variant="primary" onClick={() => onClickEdit(item)}>
                    {translation.trans('edit')}
                </Button>
                <br/>
                <Button variant="primary" onClick={() => onClickDelete(item)}>
                    {translation.trans('delete')}
                </Button>
            </td>
        </tr>);
}

DataSourcesTableItem.propTypes = {
    item: PropTypes.object,
    onClickEdit: PropTypes.func,
    onClickDelete: PropTypes.func
};

export default DataSourcesTableItem;



// WEBPACK FOOTER //
// ./js/components/DataSourcesTableItem.jsx